<template>

  <div class="hero">

    <top-navigation/>


    <div class="hero-banner">

      <div class="container">


        <div class="row">

          <div class="col-lg-6 d-flex align-items-center">

            <div>
              <div class="heading">{{ $t('body.hero.title') }}</div>
              <div class="heading accent">{{ $t('body.hero.linguaExpert') }}</div>
              <p class="text">
                {{ $t('body.hero.subtitle') }}
              </p>

              <div class="actions">

                <router-link to="/search"
                             class="btn btn-lg btn-pill btn-outline-primary fw-bold me-3 mb-3 px-4">
                  {{ $t('body.hero.searchExpert') }}
                </router-link>
                <router-link v-if="user===null" to="/register"
                             class="btn btn-lg btn-pill btn-outline-primary fw-bold me-3  mb-3 px-4">
                  {{ $t('body.hero.register') }}
                </router-link>

              </div>
            </div>

          </div>
          <div class="col-lg-6">
              <iframe width="100%" height="350" src="https://www.youtube.com/embed/C6cjoDBaSF0" title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>


          </div>

        </div>
      </div>


    </div>


    <div class="search-box">
      <div class="container">

        <div class="tabs-header">
          <a class="tab-pill" :class="{active: searchBoxActivePill===1}" @click="searchBoxActivePill = 1">
            {{ $t('expertType.translator') }}
          </a>
          <a class="tab-pill" :class="{active: searchBoxActivePill===2}" @click="searchBoxActivePill = 2">
            {{ $t('expertType.interpreter') }}
          </a>
          <a class="tab-pill" :class="{active: searchBoxActivePill===3}" @click="searchBoxActivePill = 3">
            {{ $t('expertType.teacher') }}
          </a>
        </div>

        <div class="tab-body" :class="{firstIsActive: searchBoxActivePill===1}">

          <div v-if="searchBoxActivePill===1">
            <home-search-form :categories="categories" :languages="languages" :locations="locations"
                              type="TRANSLATOR" @searchSubmitted="startSearching"/>
          </div>

          <div v-if="searchBoxActivePill===2">
            <home-search-form :categories="categories" :languages="languages" :locations="locations"
                              type="INTERPRETER" @searchSubmitted="startSearching"/>
          </div>

          <div v-if="searchBoxActivePill===3">
            <home-search-form :categories="categories" :languages="languages" :locations="locations"
                              type="TEACHER" @searchSubmitted="startSearching"/>
          </div>


        </div>

      </div>
    </div>

  </div>

  <div class="bg-white">
    <section>

      <div class="container-fluid my-5">
        <div class="row">

          <div class="col-md-6">
            <img src="../assets/theme/photo-1.png" class="w-100 p-5" :alt="$t('body.howItWorks.title')">
          </div>
          <div class="col-md-4 d-flex align-items-center">

            <div>
              <h1 class="fw-bold">{{ $t('body.howItWorks.title') }}</h1>
              <p class="lead text-primary fw-bold">
                {{ $t('body.howItWorks.subtitle') }}
              </p>

              <p>
                {{ $t('body.howItWorks.text') }}
              </p>


              <div class="row mt-5">
                <div class="col-md-6 mb-3">
                  <div class="d-flex align-items-center">
                    <img src="../assets/theme/international.png" :alt="$t('body.howItWorks.quickSearch')" class="me-3">
                    <span class="fw-bold">{{ $t('body.howItWorks.quickSearch') }}</span>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="d-flex align-items-center">
                    <img src="../assets/icon/hands.png" :alt="$t('body.howItWorks.directContact')" class="me-3">
                    <span class="fw-bold">{{ $t('body.howItWorks.directContact') }}</span>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="d-flex align-items-center">
                    <img src="../assets/icon/credit-card.png" :alt="$t('body.howItWorks.payment')" class="me-3">
                    <span class="fw-bold">{{ $t('body.howItWorks.payment') }}</span>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="d-flex align-items-center">
                    <img src="../assets/icon/achievement.png" :alt="$t('body.howItWorks.quality')" class="me-3">
                    <span class="fw-bold">{{ $t('body.howItWorks.quality') }}</span>
                  </div>
                </div>
              </div>

            </div>


          </div>

        </div>

      </div>

    </section>


    <section class="my-5" v-if="lastExperts.length>0">


      <div class="container">
        <h1 class="fw-bold">{{ $t('body.lastOrders.title') }}</h1>

        <div class="row mt-4">

          <div class="col-lg-3 col-md-6" v-for="e in lastExperts" :key="e.userView.id">
            <expert-item :expert="e"/>
          </div>

        </div>

        <div class="py-5 text-center">
          <router-link class="btn btn-primary btn-lg btn-pill" to="/search">
            {{ $t('body.lastOrders.findMore') }}
          </router-link>
        </div>

      </div>


    </section>

    <find-clients-online/>

  </div>

  <the-footer/>

</template>

<script>
// @ is an alias to /src

import TopNavigation from "../components/layout/TopNavigation";
import ExpertItem from "../components/ExpertItem";
import TheFooter from "../components/layout/TheFooter";
import FindClientsOnline from "../components/info/FindClientsOnline";
import {
  getHomePageExperts,
  getLocationList,
  getPropertyList
} from "@/repositories/GeneralDataRepository";
import HomeSearchForm from "../components/search/HomeSearchForm";
import {mapState} from "vuex";


export default {
  name: 'Home',
  components: {HomeSearchForm, FindClientsOnline, TheFooter, ExpertItem, TopNavigation},
  data() {
    return {

      languages: [],
      locations: [],
      categories: [],
      searchBoxActivePill: 1,
      lastExperts: [],
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    })
  },
  watch:{
    "$i18n.locale": function () {
      this.getProperties();
    }
  },
  methods: {
    startSearching(searchData) {
      this.$router.push(`/search?fromLang=${searchData.fromLang}&toLang=${searchData.toLang}&fromDate=${searchData.fromDate}&toDate=${searchData.toDate}&fromCost=${searchData.fromCost}&toCost=&locationId=${searchData.locationId}&jobType=${searchData.jobType}`);
    },
    getProperties(){
      getPropertyList('languages', this.$i18n.locale).then((data) => {
        this.languages = data;
      });
      getLocationList().then((data) => {
        this.locations = data;
      });
      getPropertyList('job_knowledge', this.$i18n.locale).then((data) => {
        this.categories = data;
      });
    }
  },
  created() {

    this.getProperties();

    getHomePageExperts().then(data => {
      this.lastExperts = data.slice(0, 4);
    })

  }
}
</script>

<style lang="scss" scoped>

@import "../assets/colors.scss";

.hero {
  background: $color-light-bg;

  .hero-banner {
    padding: 130px 0;

    .heading {
      font-weight: bold;
      font-size: 36px;
      color: black;
      line-height: 1.1;

      &.accent {
        color: $color-violet;
        font-size: 65px;
        @media screen and (max-width: 640px) {
          font-size: 40px;
        }
      }


    }

    .text {
      margin: 30px 0;
    }

    .actions {
      margin: 30px 0;
    }

    .video-box {
      display: block;
      position: relative;
      background: white;
      border-radius: 10px;
      width: 100%;
      height: 350px;
      margin-bottom: 20px;

      &:after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        display: block;
        width: 200px;
        height: 100px;
        background: url("../assets/logo.png") no-repeat;
        background-size: contain;
        transform: translate(-50%, -50%);
      }

    }

  }


  .search-box {

    .tabs-header {

      display: flex;
      width: 100%;

      .tab-pill {
        display: inline-block;
        text-decoration: none;
        color: $color-grey;
        font-weight: bold;
        padding: 10px 25px;

        &.active {
          background: $color-light-vilet;
          color: white;
          border-radius: 20px 20px 0 0;
        }
      }

    }

    .tab-body {
      padding: 30px;
      background: $color-light-vilet;
      color: white;
      border-radius: 20px;

      &.firstIsActive {
        border-top-left-radius: 0;
      }
    }


  }

}

</style>